// extracted by mini-css-extract-plugin
module.exports = {"wop3cuv":"wop3cuv","b3r748y":"b3r748y"};